export const VOLUME = {
  muted: 0,
  unmuted: 1,
};
